
const staff = () => import('@/views/main/staff/staff.vue')
export default {
  path: '/main/staff',
  name: 'staff',
  component: staff,
  children: []
}

